(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function ($) {
  $('body').on('click', '#getProductQuote', function () {
    var form = $('#hpy_quote_form');
    showMask();
    var productName = $('div.product .product_title').text();
    form.find('li.product_name_field input').val(productName);
    form.find('li.gf_product_id input').val(hpy_product.id);
    form.css('display', 'block');
  });
  $('body').on('click', '#hpy_quote_form .close', function (e) {
    e.stopPropagation();
    $('#hpy_quote_form').css('display', 'none');
    hideMask();
  });
  function showMask() {
    if ($('#mask').length) {
      $('#mask').css('display', 'block');
    } else {
      var mask = '<div id="mask"></div>';
      $('body').append(mask);
      $('#mask').css('display', 'block');
    }
  }
  function hideMask() {
    $('#mask').css('display', '');
  }
})(jQuery);

},{}]},{},[1]);
